export default __webpack_public_path__ + "images/0x4945970efeec98d393b4b979b9be265a3ae28a8b.png";